import React from 'react';

import { CmAlert, CmText } from '@/components/uiParts';

export const HopeMenuManagementJobNotice: React.FC = () => {
  return (
    <CmAlert>
      <CmText fontSize="sm" lineHeight="1.3">
        全ての変更は配信予約を通して行われるため
        <br />
        配信予約を忘れずにお願いします。
      </CmText>
    </CmAlert>
  );
};
